import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { VocabularyProvider } from './context/VocabularyContext';
import { GermanVocabularyApp } from './components';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <VocabularyProvider>
      <GermanVocabularyApp />
    </VocabularyProvider>
  </React.StrictMode>
); 